import { TSHIRT_CONFIG } from './config/tshirt'
import { TOTE_CONFIG_S, TOTE_CONFIG_M, TOTE_CONFIG_L } from './config/tote'
import { LONGT_CONFIG } from './config/longt_printstar'
import { TRAINER_CONFIG } from './config/trainer'
import { PARKER_CONFIG } from './config/parker'
import { BIG_SILHOUETTE_TSHIRT_CONFIG } from './config/big_silhouette'
import { LONGT_BIG_SILHOUETTE_TSHIRT_CONFIG } from './config/longt_big_silhouette'
import { UA_504401_SWEAT_CONFIG } from './config/504401_sweat'
import { UA_500101_TSHIRT_CONFIG } from './config/500101_tshirt'
import { UA_521401_PARKER_CONFIG } from './config/521401_parker'

const CONFIGS = {
  [TSHIRT_CONFIG.vendor_code]: TSHIRT_CONFIG,
  [LONGT_CONFIG.vendor_code]: LONGT_CONFIG,
  [TOTE_CONFIG_S.vendor_code]: TOTE_CONFIG_S,
  [TOTE_CONFIG_M.vendor_code]: TOTE_CONFIG_M,
  [TOTE_CONFIG_L.vendor_code]: TOTE_CONFIG_L,
  [TRAINER_CONFIG.vendor_code]: TRAINER_CONFIG,
  [PARKER_CONFIG.vendor_code]: PARKER_CONFIG,
  [BIG_SILHOUETTE_TSHIRT_CONFIG.vendor_code]: BIG_SILHOUETTE_TSHIRT_CONFIG,
  [LONGT_BIG_SILHOUETTE_TSHIRT_CONFIG.vendor_code]:
    LONGT_BIG_SILHOUETTE_TSHIRT_CONFIG,
  [UA_500101_TSHIRT_CONFIG.vendor_code]: UA_500101_TSHIRT_CONFIG,
  [UA_504401_SWEAT_CONFIG.vendor_code]: UA_504401_SWEAT_CONFIG,
  [UA_521401_PARKER_CONFIG.vendor_code]: UA_521401_PARKER_CONFIG,
  default: TSHIRT_CONFIG,
} as const

export default CONFIGS
